// extracted by mini-css-extract-plugin
module.exports = {"locationDescription":"Description_locationDescription__93jYZ","divider":"Description_divider__HwV6z"};